module.exports = __webpack_public_path__ + "media/application/assets/images/logo_partner_wko-66069162499f149f82aaf89020bb6c81.jpg";